import {
  API_BASE_URL,
  PROFILE_ENDPOINT,
  API_GET_LYNXID,
  STUDENT_ACCOUNT_DELETE,
} from "../../utils/API_CONSTANTS";

// Custom APIError class to handle API errors
class APIError extends Error {
  constructor(message, statusCode) {
    super(message);
    this.name = "APIError";
    this.statusCode = statusCode;
  }
}

// Async function to fetch user profile data from the API
const ProfileUser = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}${PROFILE_ENDPOINT}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token, // Use the token passed as a parameter
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new APIError(
        errorData.message || "An error occurred while loading your profile.",
        response.status
      );
    }

    const data = await response.json(); // Access the response data directly
    return data; // Return the user profile data
  } catch (error) {
    throw new APIError(
      error.message || "An unknown error occurred.",
      error.statusCode || 500
    );
  }
};

// Async function to fetch Lynx ID from the API
const LynxId = async (token) => {
  try {
    const response = await fetch(`${API_GET_LYNXID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token, // Use the token passed as a parameter
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new APIError(
        errorData.message || "An error occurred while loading your Lynx ID.",
        response.status
      );
    }

    const data = await response.json(); // Access the response data directly
    return data; // Return the Lynx ID data
  } catch (error) {
    throw new APIError(
      error.message || "An unknown error occurred.",
      error.statusCode || 500
    );
  }
};

// Async function to delete user account using the API
const DeleteAccount = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}${STUDENT_ACCOUNT_DELETE}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        token: token, // Use the token passed as a parameter
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new APIError(
        errorData.message || "An error occurred while deleting your account.",
        response.status
      );
    }

    const data = await response.json(); // Access the response data directly
    return data; // Return the deletion response data
  } catch (error) {
    throw new APIError(
      error.message || "An unknown error occurred.",
      error.statusCode || 500
    );
  }
};

export { LynxId, ProfileUser, DeleteAccount };
